import { FC } from 'react';
import PropogateLoader from 'react-spinners/PropagateLoader';
import styles from './styles.module.css';

interface ILoader {
  loading: boolean;
  color?: string;
  size?: number;
}

const Loader: FC<ILoader> = (props) => {

  const {
    loading,
    color = 'var(--primary)',
    size = 15,
  } = props;

  return (
    <div className={styles.loader}>
      <PropogateLoader
        color={color}
        size={size}
        loading={loading}
      />
    </div>
  );

};

export default Loader;
